import { render, staticRenderFns } from "./AgnosticBiomarker.vue?vue&type=template&id=77f23833&scoped=true"
import script from "./AgnosticBiomarker.vue?vue&type=script&lang=js"
export * from "./AgnosticBiomarker.vue?vue&type=script&lang=js"
import style0 from "./AgnosticBiomarker.vue?vue&type=style&index=0&id=77f23833&prod&lang=scss&scoped=true"
import style1 from "./AgnosticBiomarker.vue?vue&type=style&index=1&id=77f23833&prod&lang=scss&scoped=true"
import style2 from "./AgnosticBiomarker.vue?vue&type=style&index=2&id=77f23833&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f23833",
  null
  
)

export default component.exports